import { IValidationFunction } from "./interface";

/**
 * Validates a name for uniqueness and format.
 *
 * Checks in order:
 * 1. Blank/whitespace-only names are rejected.
 * 2. Duplicate names (case-insensitive, trimmed) are rejected using `target.options.existingValues`.
 * 3. Names containing characters outside alphanumerics, hyphens, underscores, and spaces are rejected.
 *
 * @param _ - Unused back-end URL parameter required by the shared validation function signature.
 * @param target - Validation target containing the candidate name and optional existing values.
 * @returns A resolved promise with a valid or invalid result for the candidate name.
 */
export const checkName: IValidationFunction = async (_, target) => {
  let valid = false;
  let validationText: string = "Not validated";
  if (target.value.trim() === "") {
    valid = false;
    validationText = "Name cannot be blank";
  } else if (
    (target.options?.existingValues ?? []).findIndex(
      (s) => s.trim().toLowerCase() === target.value.trim().toLowerCase(),
    ) >= 0
  ) {
    valid = false;
    validationText = "This name is taken";
  } else if (target.value.trim().match(/^[A-Za-z0-9_ -]*$/) === null) {
    valid = false;
    validationText = "Only alphanumeric characters and -_ can be used";
  } else {
    valid = true;
    validationText = "Successfully validated";
  }
  return { success: true, data: { valid, validationText } };
};
